import { useRecordContext } from 'react-admin'
import usePhysicalOrders from '../hooks/usePhysicalOrders'
import MenuButton from '@/components/MenuButton'
import { ReactElement } from 'react'

type Props = {
  label?: string | ReactElement | boolean
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const DownloadCsvButton = (_: Props) => {
  const record = useRecordContext()
  const { downloadBatchCsv } = usePhysicalOrders()

  const handleClick = (id: string) => {
    if (!record) return

    downloadBatchCsv({
      batchId: record.id as number,
      filters: {
        late: id === 'late',
        pending: id === 'opened',
        refunded: id === 'refunded'
      }
    })
  }

  return (
    <MenuButton
      variant="contained"
      label="Download CSV"
      options={[
        { id: 'opened', name: 'Open Orders' },
        { id: 'all', name: 'All Orders' },
        { id: 'late', name: 'Late Orders' },
        { id: 'refunded', name: 'Refunded Orders' }
      ]}
      onClick={handleClick}
      dataTestId="download-csv-button"
    />
  )
}

export default DownloadCsvButton
